import { css } from "@emotion/css";
import classNames from "classnames";
import { lotteryHeaderMenu } from "constants/common";
import { colors } from "constants/theme";
import { LotteryMenuHeader } from "models/commonModel";
import { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import titleBgMB from 'assets/images/bg/xsmb.png';
import titleBgMN from 'assets/images/bg/MN.png';
import titleBgMT from 'assets/images/bg/MT.png';
import titleXSVIP from 'assets/images/bg/XSVIP.png';
import titlexsFast from 'assets/images/bg/xsFast.png';
import titleAseanBall from 'assets/images/bg/AseanBall.png';
import { useSearchParams } from "react-router-dom";

interface Props {
    onSelectGame: (ltId: number) => void;
    lotteryIdActive: number;
}

function LotterySidebar(props: Props) {
    const { onSelectGame, lotteryIdActive } = props;
    const [lotteryMenu, setLotteryMenu] = useState<(LotteryMenuHeader & { idGroup: string })[]>([]);
    const [searchParams] = useSearchParams();
    const ltId = Number(searchParams.get("ltId") || "0");
    const [openTab, setOpenTab] = useState<string | null>(null);

    useEffect(() => {
        const today = new Date().getDay();
        let foundGroup: string | null = null;

        const newLotteryMenu = lotteryHeaderMenu.map((group) => {
            const originalTitle = group.title;
            let title = originalTitle;
            let children = group.child;

            if (group.type === "MN" || group.type === "MT") {
                title = group.type === "MN" ? "Miền Nam Hôm Nay" : "Miền Trung Hôm Nay";
                children = group.child.filter((game) => game.openDay === today);
            }

            const idGroup = `${group.type}-${originalTitle}`;

            if (children.some((game) => game.ltid === ltId)) {
                foundGroup = idGroup;
            }

            return {
                ...group,
                title,
                child: children,
                idGroup,
            };
        });

        setLotteryMenu(newLotteryMenu);

        if (foundGroup) {
            setOpenTab(foundGroup);
        } else if (newLotteryMenu.length > 0) {
            setOpenTab(newLotteryMenu[0].idGroup);
        }
    }, [ltId]);

    const toggleGroup = (idGroup: string) => {
        setOpenTab(idGroup);
    };

    return (
        <div className={styles.wrapSidebar}>
            {lotteryMenu.map((group) => {
                const isActive = group.idGroup === openTab;

                return (
                    <div
                        className={classNames(styles.groupGame, { activeContent: isActive })}
                        key={group.idGroup}
                    >
                        <div
                            className={classNames(styles.headingGroup, group.type, { activeTitle: isActive })}
                            onClick={() => toggleGroup(group.idGroup)}
                        >
                            <h6>{group.title}</h6>
                            <span className={classNames({ activeIcon: isActive })}>
                                <FaChevronDown size={16} />
                            </span>
                        </div>
                        <div className={classNames(styles.listGame, { activeTab: isActive })}>
                            {group.child.map((game) => (
                                <div
                                    className={classNames(styles.gameItem, {
                                        active: game.ltid === lotteryIdActive,
                                    })}
                                    key={game.ltid}
                                    onClick={() => onSelectGame(game.ltid)}
                                >
                                    <img
                                        src={require(`assets/images/icons-lt/${game.ltid}.png`)}
                                        alt=""
                                    />
                                    <p>{game.label}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

const styles = {
    wrapSidebar: css`
        height: 100%;
    `,
    groupGame: css`
        margin-bottom: 8px;
        &.activeContent {
            border: 1px solid ${colors.white};
            border-radius: 10px;
            background: #002287;
        }
    `,
    headingGroup: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: linear-gradient(to left, #184de5, #002dba);
        border-radius: 8px;
        cursor: pointer;
        position: relative;
        h6 {
            padding: 16px 10px;
            color: ${colors.white};
            position: relative;
        }
        span {
            display: inline-block;
            color: ${colors.white};
            padding: 5px;
            transition: 0.2s all ease-out;
            z-index: 1;
            position: absolute;
            right: 40px;
            top: 25%;
            &.activeIcon {
                transform: rotate(180deg);
                transition: 0.2s all ease-out;
            }
        }
        &.activeTitle {
            border: 1px solid #f4ff23;
        }
        &.MB::before,
        &.MN::before,
        &.MT::before,
        &.FAST::before,
        &.AseanBall::before,
        &.XSVIP::before {
            top: 0;
            right: 0;
            position: absolute;
            content: "";
            width: 100%;
            height: 100%;
            z-index: 0;
        }
        &.MB::before {
            background: url(${titleBgMB}) no-repeat right;
            background-size: contain;
        }
        &.MN::before {
            background: url(${titleBgMN}) no-repeat right;
            background-size: contain;
        }
        &.MT::before {
            background: url(${titleBgMT}) no-repeat right;
            background-size: contain;
        }
        &.FAST::before {
            background: url(${titlexsFast}) no-repeat right;
            background-size: contain;
        }
        &.AseanBall::before {
            background: url(${titleAseanBall}) no-repeat right;
            background-size: contain;
        }
        &.XSVIP::before {
            background: url(${titleXSVIP}) no-repeat right;
            background-size: contain;
        }
    `,
    listGame: css`
        height: 0;
        overflow: hidden;
        transition: 0.2s all ease-out;
        &.activeTab {
            height: 200px;
            overflow: auto;
            transition: 0.2s all ease-out;
            &::-webkit-scrollbar {
                width: 5px;
            }
            &::-webkit-scrollbar-track {
                box-shadow: inset 0 0 5px grey;
            }
            &::-webkit-scrollbar-thumb {
                background: #f4ff23;
            }
        }
    `,
    gameItem: css`
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 15px 12px;
        cursor: pointer;
        margin-bottom: 2px;
        color: ${colors.white};
        border-bottom: 1px solid #4775ff;
        &:hover,
        &.active {
            p {
                font-weight: bold;
                color: #f4ff23;
            }
        }
        img {
            width: 35px;
        }
    `,
};

export default LotterySidebar;
